export default {
  title: 'Marchi',
  form: {
    name: {
      placeholder: 'Cerca marchio...',
    },
  },
  fields: {
    id: '#',
    name: 'Nome',
    address: 'Indirizzo',
    subdomain: 'Sottodominio',
    shop_url: 'URL negozio',
    companies: 'Aziende',
    slug: 'Slug',
    actions: '',
  },
  empty_list: 'Nessun marchio ancora',
  modals: {
    delete_franchise: {
      title: 'Sei sicuro di voler eliminare il marchio {{name}}?',
    },
  },
  buttons: {
    new_franchise: '+ Aggiungi marchio',
    export_restaurants: 'Esporta ristoranti',
    edit: 'Modifica',
    delete: 'Elimina',
    view_dashboard_as_owner: 'Visualizza dashboard come titolare',
    open_shop: 'Apri negozio',
  },
  toasts: {
    failed_to_load_data: 'Caricamento dati non riuscito',
    failed_to_delete_franchise: 'Impossibile eliminare il marchio',
    franchise_got_deleted: 'Marchio eliminato',
    failed_to_create_magic_link: 'Creazione magic link non riuscita',
    no_owner_to_log_in_as: 'Nessun proprietario del ristorante con cui accedere',
  },
};
